import React, { useState } from 'react';
import Articolo1 from '../assets/giornale1.webp';
import Articolo2 from '../assets/Gazz-MN-mezza-pagina-275x200-20-settembre-2022--1024x745.webp';
import Articolo3 from '../assets/sito-giugno-mezza-pagina-275x200-MAGGIO-2022--1024x445.webp';
import Articolo4 from '../assets/GIUGNO-sito-2023-speciale-Edilizia-Zanca-La-Voce-280x400-1-.webp';
import Articolo5 from '../assets/ZANCA-Sponsor-x-sito.webp';
import Articolo6 from '../assets/Senza-titolo-1-1-1024x681.webp';
import Articolo7 from '../assets/maggio26lavoce.pdf';
import Articolo8 from '../assets/50annilavoce.pdf';
import Articolo7foto from '../assets/lavoce2.png';
import Articolo8foto from '../assets/lavoce1.png';
import { motion } from 'framer-motion';

const articles = [
  {
    id: 1,
    imageUrl: Articolo7foto,
    pdfUrl: Articolo7,
    type: 'pdf',
    title: 'La Voce - Maggio 2026'
  },
  {
    id: 2,
    imageUrl: Articolo8foto,
    pdfUrl: Articolo8,
    type: 'pdf',
    title: '50 anni Zanca'
  },
  { id: 3, imageUrl: Articolo1, type: 'image' },
  { id: 4, imageUrl: Articolo2, type: 'image' },
  { id: 5, imageUrl: Articolo3, type: 'image' },
  { id: 6, imageUrl: Articolo4, type: 'image' },
  { id: 7, imageUrl: Articolo5, type: 'image' },
  { id: 8, imageUrl: Articolo6, type: 'image' },
];

function Newspaper() {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [overlayOpacity, setOverlayOpacity] = useState(0);

  const openOverlay = (article) => {
    setSelectedArticle(article);
    setOverlayVisible(true);
    setOverlayOpacity(0); // Imposta l'opacità a 0 prima di visualizzarlo
    setTimeout(() => setOverlayOpacity(100), 0); // Cambia l'opacità dopo un breve ritardo
  };

  const closeOverlay = () => {
    setOverlayOpacity(0); // Inizia a chiudere l'overlay
    setTimeout(() => {
      setOverlayVisible(false);
      setSelectedArticle(null); // Rimuovi l'articolo dopo la transizione
    }, 300); // Attendi il tempo della transizione
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }} // Imposta i valori iniziali
      animate={{ opacity: 1, y: 0 }} // Imposta i valori finali
      transition={{ duration: 1 }} // Durata dell’animazione in secondi
      className="px-2 md:px-0"
    >
    <div className="min-h-screen bg-gray-100 p-4">
      <h1 className="text-3xl font-bold text-center mb-8">Hanno parlato di noi</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {articles.map(article => (
          <div
            key={article.id}
            onClick={() => openOverlay(article)}
            className="relative bg-center bg-cover bg-no-repeat cursor-pointer h-48 rounded-lg shadow-lg transition-transform transform hover:scale-105"
            style={{ backgroundImage: `url(${article.imageUrl})` }}
          >
            <div className="absolute inset-0 bg-black opacity-0 hover:opacity-30 transition-opacity rounded-lg"></div>
          </div>
        ))}
      </div>

      {/* Overlay */}
{isOverlayVisible && selectedArticle && (
  <div
    className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-80 transition-opacity duration-300"
    style={{
      opacity: overlayOpacity,
      pointerEvents: overlayOpacity ? 'auto' : 'none'
    }}
    onClick={closeOverlay}
  >
    <div
      className="relative w-full max-w-6xl h-[90vh] p-4"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={closeOverlay}
        className="absolute top-6 right-8 text-white text-4xl z-50 hover:scale-110"
      >
        &times;
      </button>

      {selectedArticle.type === 'image' ? (
        <img
          src={selectedArticle.imageUrl}
          alt="Articolo"
          className="w-full h-full object-contain rounded-lg shadow-lg"
        />
      ) : (
        <iframe
          src={selectedArticle.pdfUrl}
          title={selectedArticle.title}
          className="w-full h-full rounded-lg bg-white"
        />
      )}
    </div>
  </div>
)}
    </div>
    </motion.section>
  );
}

export default Newspaper;
